import React, {useContext} from "react";
import {Col, Container, Row, Form, Button} from "react-bootstrap";
import StatusBar from "../StatusBar/StatusBar";
import {useIntl} from "react-intl";
import messages from "../../i18n/messages";
import './MessageBoard.css'
import MaxiIcon from "../Maxiicon/MaxiIcon";
import {ModalContext} from "../../contexts/modal/ModalContext";
import {LoadingContext} from "../../contexts/loading/LoadingContext";
import {sendMessage} from "../../utils/MsgUtil";
import MessageReply from "./MessageReply/MessageReply";

const MessageBoard = () => {
    const intl = useIntl();
    const [, setModalContext] = useContext(ModalContext);
    const [, setLoadingContext] = useContext(LoadingContext);
    const [msgState, setMsgState] = React.useState({
        name: '',
        email: '',
        message: '',
        messageLength: 0,
    });



    async function onSubmitClick() {
        if (msgState.name === '' || msgState.message === '') {
            setModalContext({
                isShow: true,
                title: intl.formatMessage(messages.errMsgTitle),
                content: intl.formatMessage(messages.errMsgMissingInfoError),
                onConfirm: () => {},
            });
        } else if (msgState.message.length > 200 || msgState.email.length > 100 || msgState.name.length > 50) {
            setModalContext({
                isShow: true,
                title: intl.formatMessage(messages.errMsgTitle),
                content: intl.formatMessage(messages.errMsgExceedTextLengthLimitError),
                onConfirm: () => {},
            });
        } else {
            try {
                setLoadingContext({
                    isLoading: true,
                    loadingText: '',
                });
                const response = await sendMessage(msgState.name, msgState.email, msgState.message);
                if (!response.ok) {
                    if (response.status === 509) {
                        setModalContext({
                            isShow: true,
                            title: intl.formatMessage(messages.errMsgTitle),
                            content: intl.formatMessage(messages.msgSubmitLimitText),
                            onConfirm: () => {},
                        });
                    } else {
                        setModalContext({
                            isShow: true,
                            title: intl.formatMessage(messages.errMsgTitle),
                            content: intl.formatMessage(messages.errMsgServerError),
                            onConfirm: () => {},
                        });
                    }
                } else {
                    const msgId = await response.text();
                    setModalContext({
                        isShow: true,
                        title: '',
                        content: intl.formatMessage(messages.msgSubmittedText) + ' ' + intl.formatMessage(messages.queryReplyWithMsgIdText, {msgId}),
                        onConfirm: () => {
                            navigator.clipboard.writeText(msgId);
                        },
                    });
                    setMsgState({
                        name: '',
                        email: '',
                        message: '',
                        messageLength: 0,
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoadingContext({
                    isLoading: false,
                    loadingText: '',
                });
            }
        }
    }

    const onClientNameChange = (event) => {
        setMsgState({
            ...msgState,
            name: event.target.value.trim(),
        });
    }

    const onClientEmailChange = (event) => {
        setMsgState({
            ...msgState,
            email: event.target.value.trim(),
        });
    }

    const onMsgChange = (event) => {
        setMsgState({
            ...msgState,
            message: event.target.value,
            messageLength: event.target.value.length,
        });
    }

    return (
        <Container fluid className={'msg-container'}>
            <StatusBar />
            <Row>
                <Col xs={12}>
                    <h2><MaxiIcon iconName={'faEnvelope'}/> {intl.formatMessage(messages.messageBoardLabel)}</h2>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col xs={12} lg={{span: 4, offset: 4}}>
                    <Form>
                        <Form.Group className={'msg-input-label'}>
                            <Form.Label>{intl.formatMessage(messages.nameLabel)}<sup className={'msg-star-icon'}>*</sup>&nbsp;<span className={'msg-info-text'}>({intl.formatMessage(messages.starFieldLabel)} {intl.formatMessage(messages.msgInputLimitText, {lengthLimit: 50})})</span></Form.Label>
                            <Form.Control type="text" value={msgState.name} onChange={onClientNameChange}/>
                        </Form.Group>
                        <br/>
                        <Form.Group className={'msg-input-label'}>
                            <Form.Label>{intl.formatMessage(messages.emailLabel)} <span
                                className={'msg-info-text'}>({intl.formatMessage(messages.msgInputLimitText, {lengthLimit: 100})})</span></Form.Label>
                            <Form.Control type="email" value={msgState.email} onChange={onClientEmailChange}/>
                        </Form.Group>
                        <br/>
                        <Form.Group className={'msg-input-label'}>
                            <Form.Label>{intl.formatMessage(messages.leaveMsgLabel)}<sup className={'msg-star-icon'}>*</sup>&nbsp;<span className={'msg-info-text'}>({intl.formatMessage(messages.starFieldLabel)} {intl.formatMessage(messages.msgContentLimitText)})</span></Form.Label>
                            <Form.Control as="textarea" rows={5} value={msgState.message} onChange={onMsgChange} />
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={{span: 4, offset: 4}}>
                    <div className={'text-length'}>{msgState.messageLength}/200</div>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                    <Button onClick={onSubmitClick}>
                        <MaxiIcon iconName={'faPaperPlane'}/>&nbsp;{intl.formatMessage(messages.submitButtonLabel)}
                    </Button>
                    <div className={'msg-info-text'}>**{intl.formatMessage(messages.msgSubmitLimitText)}</div>
                </Col>
            </Row>
            <hr />
            <MessageReply />
        </Container>
    );
}

export default MessageBoard;